import { RefObject } from 'react';
import { useIsomorphicLayoutEffect } from 'fronton-react';

const SUGGESTIONS_BOTTOM_OFFSET = 80;

export const getSuggestionsContainerMaxHeight = (top: number, viewportHeight = window.innerHeight) =>
  Math.max(0, viewportHeight - top - SUGGESTIONS_BOTTOM_OFFSET);

export const useSuggestionsContainerMaxHeight = (ref: RefObject<HTMLDivElement>, enabled: boolean) => {
  useIsomorphicLayoutEffect(() => {
    if (!enabled) {
      return;
    }

    const element = ref.current;
    if (!element) {
      return;
    }

    const updateMaxHeight = () => {
      const { top } = element.getBoundingClientRect();
      element.style.maxHeight = `${getSuggestionsContainerMaxHeight(top)}px`;
    };

    updateMaxHeight();

    window.addEventListener('resize', updateMaxHeight);
    const observer = new MutationObserver(updateMaxHeight);
    observer.observe(element, { attributes: true, attributeFilter: ['style'] });

    return () => {
      window.removeEventListener('resize', updateMaxHeight);
      observer.disconnect();
      element.style.maxHeight = '';
    };
  }, [enabled, ref]);
};
